module.exports = __webpack_public_path__ + "static/media/apple.50e69abb.png";